import { useEffect } from "react"
import { getAllInvoiceReserved, updateReservedFactorForMoadian } from "../../../../api/requestAxios/invoice"
import { getProvince } from "../../../../api/requestAxios/userInfo"
import CustomValuesHook from "../../../../functions/myHooks/CustomValuesHook"
import { ErrorToast } from "../../../../shared"
import CityProvince from "./modalContent/cityProvince"
import './style.scss'
import { Modal } from 'react-bootstrap';
import btnClose from "../../../../assets/images/svg/close_modal_icon.svg";
import ModalContent from "./modalContent"

const ModalInfo = ({
    fromPage,
    setShowModalInfo,
    showModalInfo,
    officialFactorId,
    reservedInAccepInvoice,
    reservedInPendInvoice,
    item,
    loadingModal,
    infoModal,
    createCityList,
    infoForm,
    handleInfoForm,
    isUpdate,
    setIsReserved
}) => {




    const [infoModel, setInfoModel] = CustomValuesHook({
        OfficialFactorId: '',
        BuyerNameReservedOrReturned: '',
        NationalCodeReservedOrReturned: '',
        DescriptionReservedOrReturned: '',
        TotalAmountReservedOrReturned: '',
        AddressReservedOrReturned: '',
        PhoneReservedOrReturned: '',
        ResidencePostalCodeReservedOrReturned: '',
        CityIdReservedOrReturned: '',
        FactorIssueType: '',
        EmailReservedOrReturned: ''

    })

    useEffect(() => {
        setInfoModel(infoModal)
    }, [infoModal])


    return (
        <Modal show={showModalInfo} onHide={() => {
            setShowModalInfo(false)
           if(fromPage==='pending') setIsReserved(false)

        }} animation={true} dir="rtl" className="info-reserve-modal">
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                    {' تکمیل اطلاعات'}
                    <img
                        onClick={() => {
                            setShowModalInfo(false)
                            if(fromPage==='pending') setIsReserved(false)
                        }}
                        alt={' تکمیل اطلاعات'}
                        src={btnClose}
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='invoice-modal-content-view'>
                <ModalContent
                    fromPage={fromPage}
                    handleInfoForm={handleInfoForm}
                    infoForm={infoForm}
                    infoModel={infoModel}
                    setInfoModel={setInfoModel}
                    createCityList={createCityList}
                    setShowModalInfo={setShowModalInfo}
                    reservedInAccepInvoice={reservedInAccepInvoice}
                    reservedInPendInvoice={reservedInPendInvoice}
                    item={item}
                    provLoading={infoForm?.provLoading}
                    getLoading={loadingModal}

                />
            </Modal.Body>
        </Modal>
    )
}
export default ModalInfo